import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import Alerts from '../../../../prototypes/Alerts';
import EtelAPI from '../../../../api/EtelAPI';

import WholesaleSettings from './WholesaleSettings';
import WholesaleContacts from '../../contacts/components/WholesaleContacts';
import WholesaleNumbers from '../../numbers/components/WholesaleNumbers';
import WholesaleSIPInfo from '../../sipinfo/components/WholesaleSIPInfo';
import WholesaleSIPInbound from '../../sipinbound/components/WholesaleSIPInbound';
import WholesaleResporgs from '../../resporgs/components/WholesaleResporgs';
import WholesaleUtilityNumbers from './WholesaleUtilityNumbers';
import WholesaleDefaultPrograms from './WholesaleDefaultPrograms';
import WholesaleTFNSplitEditDialog from '../../tfnsplit/components/WholesaleTFNSplitEditDialog';
import { ProgramTabContainer, ProgramTabPanel, ProgramTabPanelItem } from '../../../../presentation/ProgramTabContainer';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import Overlay from '../../../../presentation/Overlay';

class WholesaleCompanyDialog extends Component {

  constructor( props ) {
    super( props );

    this.state = {
      row: this.props.row === undefined ? {} : this.props.row,
      activeKey: 0,
      startingCarriers: [],
      startingResporgs: [],
      startingSIP: false,
      changed: false
    };

    this.title = 'Wholesale Company';
    this.company = '';

    /*
      Keep track of where the dialog was popped up:
      0: CompanyList
      1. WholesaleContactList
      2. WholesaleNumbersList (Doesn't open the dialog)
      3. WholesaleSIPInfoList
      4. WholesaleSIPInboundList
      5. WholesaleResporgList (Doesn't open the dialog)
    */
    this.startingKey = props.activeKey;

    this.onHandleChange = this.onHandleChange.bind( this );
    this.onHandleClickSave = this.onHandleClickSave.bind( this );
    this.onHandleClickDelete = this.onHandleClickDelete.bind( this );
    this.onHandleChangeTab = this.onHandleChangeTab.bind( this );
    this.onHandleException = this.onHandleException.bind( this );
    this.onHandleClose = this.onHandleClose.bind( this );
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/

  componentDidMount() {
    this.alert = new Alerts( this.props.bugsnag, this.props.dispatch );
  }

  componentWillReceiveProps( nextProps ) {
    this.setState( {
      row: nextProps.row === undefined ? {} : nextProps.row,
      activeKey: nextProps.row === undefined ? 0 : nextProps.activeKey,
      changed: false,
    }, () => {
      const row = { ...this.state.row };

      this.setState( {
        startingCarriers: row.carriers === undefined ? [] : row.carriers,
        startingResporgs: row.resporgs === undefined ? [] : row.resporgs,
        startingSIP: row.Inbound_SIP,
        changed: false,
      } );

      // Skip activeKey === 0, as that component gets the main wholesale
      // company search query.
      if ( this.state.activeKey !== 0 && this.props.show !== false ) {
        const activeKey = this.state.activeKey;
        const params = [];
        let companyID = 0;

        /*
          activeKey values:
          1 = Wholesale Contacts  -- WS_Company_ID
          2 = Wholesale Numbers   -- Company_ID
          3 = SIP Info            -- COMPANY_ID
          4 = SIP Inbound         -- COMPANY_ID
          5 = TFN/DID Split       -- WS_Company_ID
          6 = Utility Numbers     -- WS_Company_ID
          7 = Default Programs    -- WS_COMPANY_ID
          8 - Resporgs            -- WS_Company_ID
        */
        if ( [1, 5, 6, 8].includes( activeKey ) ) {
          companyID = row.WS_Company_ID;
        } else if ( [2].includes( activeKey ) ) {
          companyID = row.Company_ID;
        } else if ( [3, 4].includes( activeKey ) ) {
          companyID = row.COMPANY_ID;
        } else if ( [7].includes( activeKey ) ) {
          companyID = row.WS_COMPANY_ID;
        }

        params.push( { Company_ID: companyID } );

        this.getWholesaleCompany( params ).then( ( companyResults ) => {
          const result = companyResults[0];

          this.setState( {
            row: result,
            startingCarriers: result.carriers === undefined ? [] : result.carriers,
            startingResporgs: result.resporgs === undefined ? [] : row.resporgs,
            startingSIP: result.Inbound_SIP,
            changed: false
          } );
        } ).catch( ( exception ) => {
          this.onHandleException( exception );
        } );
      }
    } );
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/

  getData() {
    const params = [
      { Company_ID: this.state.row.Company_ID }
    ];

    this.getWholesaleCompany( params ).then( ( companyResults ) => {
      const result = companyResults[0];

      this.setState( {
        row: result,
        startingCarriers: result.carriers === undefined ? [] : result.carriers,
        startingResporgs: result.resporgs === undefined ? [] : result.resporgs,
        startingSIP: result.Inbound_SIP
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  getWholesaleCompany( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale' );

      api.get( params ).then( ( companyResults ) => {
        resolve( companyResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  updateWholesaleCompany( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale' );

      api.update( params ).then( ( companyResults ) => {
        resolve( companyResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  insertWholesaleCompany( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale' );

      api.insert( params ).then( ( companyResults ) => {
        resolve( companyResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  deleteCarrier( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/carrier' );

      api.delete( params ).then( ( carrierResults ) => {
        resolve( carrierResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  insertCarrier( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/carrier' );

      api.insert( params ).then( ( carrierResults ) => {
        resolve( carrierResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  insertResporg( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/resporgs' );

      api.insert( params ).then( ( carrierResults ) => {
        resolve( carrierResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  deleteResporg( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'wholesale/resporgs' );

      api.delete( params ).then( ( carrierResults ) => {
        resolve( carrierResults );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/

  doLogOff() {
    const { dispatch, auth, history } = this.props;
    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  onHandleException( e ) {
    const { dispatch, bugsnag } = this.props;
    const alerts = new Alerts( bugsnag, dispatch );
    const status = e.status === undefined ? 0 : e.status;
    if ( status === 410 ) {
      alerts.INFO( this.title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      alerts.INFO( this.title, e.statusText, 5000 );
    } else {
      if ( e.statusText !== undefined ) {
        alerts.CRITICAL( this.title, e, false );
      } else {
        alerts.CRITICAL( this.title, e );
      }
    }
  }

  onHandleClose( e ) {
    this.setState( {
      changed: false
    }, () => {
      if ( this.props.onClose !== undefined ) {
        this.props.onClose( e );
      }
    } );
  }
  /****************************************************************************
   * HELPER METHODS
   ***************************************************************************/

  getCarriersToDelete( row ) {
    // Snapshot of the starting carriers
    const startingCarriers = [...this.state.startingCarriers];
    // Carriers upon clicking save to check if any were added/deleted
    const endingCarriers = row.carriers === undefined
      ? []
      : [...row.carriers];
    const carriersToDelete = [];

    // Find if there are any carriers to delete
    for ( let i = 0; i < startingCarriers.length; ++i ) {
      const startingCarrier = startingCarriers[i];
      let found = false;

      for ( let j = 0; j < endingCarriers.length && !found; ++j ) {
        const endingCarrier = endingCarriers[j];

        if ( startingCarrier.CarrierID === endingCarrier.CarrierID ) {
          found = true;
        }
      }

      if ( !found ) {
        carriersToDelete.push( startingCarrier );
      }
    }

    return carriersToDelete.map( ( carrier ) => {
      return carrier.WS_Company_Carrier_ID;
    } );
  }

  getCarriersToInsert( row ) {
    // Snapshot of the starting carriers
    const startingCarriers = [...this.state.startingCarriers];
    // Carriers upon clicking save to check if any were added/deleted
    const endingCarriers = row.carriers === undefined
      ? []
      : [...row.carriers];
    let carriersToInsert = [];

    for ( let i = 0; i < endingCarriers.length; ++i ) {
      const endingCarrier = endingCarriers[i];
      let found = false;

      for ( let j = 0; j < startingCarriers.length && !found; ++j ) {
        const startingCarrier = startingCarriers[j];

        if ( startingCarrier.CarrierID === endingCarrier.CarrierID ) {
          found = true;
        }
      }

      if ( !found ) {
        carriersToInsert.push( endingCarrier );
      }
    }

    return carriersToInsert.map( ( carrierToInsert ) => {
      return {
        WS_Company_Carrier_ID: 0,
        CarrierID: carrierToInsert.CarrierID,
        CarrierName: carrierToInsert.CarrierName,
        WS_Company_ID: row.Company_ID
      };
    } );
  }

  getResporgsToDelete( row ) {
    // Snapshot of the starting carriers
    const startingResporgs = [...this.state.startingResporgs];
    // Carriers upon clicking save to check if any were added/deleted
    const endingResporgs = row.resporgs === undefined
      ? []
      : [...row.resporgs];
    const resporgsToDelete = [];

    // Find if there are any carriers to delete
    for ( let i = 0; i < startingResporgs.length; ++i ) {
      const startingResporg = startingResporgs[i];
      let found = false;

      for ( let j = 0; j < endingResporgs.length && !found; ++j ) {
        const endingCarrier = endingResporgs[j];

        if ( startingResporg.ResporgID === endingCarrier.ResporgID ) {
          found = true;
        }
      }

      if ( !found ) {
        resporgsToDelete.push( startingResporg );
      }
    }

    return resporgsToDelete.map( ( resporg ) => {
      return resporg.WS_Company_Resporg_ID;
    } );
  }

  getResporgsToInsert( row ) {
    // Snapshot of the starting resporgs
    const startingResporgs = [...this.state.startingResporgs];

    // Resporgs upon clicking save to check if any were added/deleted
    const endingResporgs = row.resporgs === undefined
      ? []
      : [...row.resporgs];
    let resporgsToInsert = [];

    for ( let i = 0; i < endingResporgs.length; ++i ) {
      const endingResporg = endingResporgs[i];
      let found = false;

      for ( let j = 0; j < startingResporgs.length && !found; ++j ) {
        const startingResporg = startingResporgs[j];

        if ( startingResporg.ResporgID === endingResporg.ResporgID ) {
          found = true;
        }
      }

      if ( !found ) {
        resporgsToInsert.push( endingResporg );
      }
    }

    return resporgsToInsert.map( ( resporgToInsert ) => {
      return {
        WS_Company_ID: this.state.row.Company_ID,
        ResporgID: resporgToInsert.ResporgID,
        Active: this.state.row.Active
      };
    } );
  }

  /****************************************************************************
   * EVENT HANDLING
   ***************************************************************************/

  onHandleChangeTab( key, content ) {

    const { bugsnag, dispatch } = this.props;
    const alert = new Alerts( bugsnag, dispatch );

    if ( this.state.activeKey === key ) {
      return;
    }

    if ( this.state.changed === true ) {
      alert.WARNING( 'Unsaved Changes', 'You must save the changes before you navigate to new tab.', 2500 );
      return;
    }

    this.setState( {
      activeKey: parseInt( key, 10 )
    } );
  }

  isRowChanged( originalRow, updatedRow ) {
    const keys = Object.keys( originalRow );
    if ( keys !== undefined ) {
      if ( keys.length > 0 ) {
        for ( var index = 0; index < keys.length; index++ ) {
          const key = keys[index];
          if ( typeof originalRow[key] !== "object" ) {
            if ( originalRow[key] !== updatedRow[key] ) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }

  onHandleChange( updatedRow ) {
    const originalRow = this.state.row;
    const isChanged = this.isRowChanged( originalRow, updatedRow );

    this.setState( {
      row: updatedRow,
      changed: isChanged
    } );
  }

  onHandleInsertCompany( params ) {
    const row = { ...this.state.row };

    this.insertWholesaleCompany( params ).then( ( companyResults ) => {
      this.setState( {
        row: companyResults.data[0],
        changed: false
      }, () => {
        /**
         * Inserts the carriers after the Wholesale Company has been created.
         *
         * @returns {Array<Promise>} An array of promises to insert the carriers for the Wholesale Company.
         */
        const carriersInsert = () => {
          // Update the parameters to have the newly inserted company ID.
          const carriersToInsert = this.getCarriersToInsert( row ).map( ( carrierToInsert ) => {
            carrierToInsert.WS_Company_ID = this.state.row.Company_ID;

            return carrierToInsert;
          } );

          return carriersToInsert.map( ( carrierToInsert ) => {
            return this.insertCarrier( carrierToInsert );
          } );
        };

        /**
         * Inserts the resporgs after the Wholesale Company has been created.
         *
         * @returns {Array<Promise>} An array of promises to insert the resporgs for the Wholesale Company.
         */
        const resporgsInsert = () => {
          const resporgsToInsert = this.getResporgsToInsert( row ).map( ( resporgToInsert ) => {
            resporgToInsert.WS_Company_ID = this.state.row.Company_ID;
            resporgToInsert.Active = this.state.row.Active;

            return resporgToInsert;
          } );

          return resporgsToInsert.map( ( resporgToInsert ) => {
            return this.insertResporg( resporgToInsert );
          } );
        };

        /**
         * Pass the results to the parent (CompanyList).
         */
        const passResultToParent = () => {
          if ( this.state.activeKey === this.startingKey ) {
            const args = {
              row: companyResults.data[0]
            };

            this.props.onSave( args );
          }
        };

        const promises = [...carriersInsert(), ...resporgsInsert()];

        const all = () => Promise.all( promises ).then( ( results ) => {
          this.getData();

          this.alert.SUCCESS( this.title, `Successfully inserted ${this.title}.`, 2500 );
        } ).catch( ( exception ) => {
          this.onHandleException( exception );
        } );

        all();
        passResultToParent();
      } );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  onHandleUpdateCompany( params ) {
    const row = { ...this.state.row };
    const activeKey = this.state.activeKey;
    const carriersToDelete = this.getCarriersToDelete( row );
    const carriersToInsert = this.getCarriersToInsert( row );
    const resporgsToDelete = this.getResporgsToDelete( row );
    const resporgsToInsert = this.getResporgsToInsert( row );
    const promises = [];

    promises.push( this.updateWholesaleCompany( params ) );

    for ( let i = 0; i < carriersToDelete.length; ++i ) {
      promises.push( this.deleteCarrier( carriersToDelete[i] ) );
    }

    for ( let i = 0; i < carriersToInsert.length; ++i ) {
      promises.push( this.insertCarrier( carriersToInsert[i] ) );
    }

    for ( let i = 0; i < resporgsToDelete.length; ++i ) {
      promises.push( this.deleteResporg( resporgsToDelete[i] ) );
    }

    for ( let i = 0; i < resporgsToInsert.length; ++i ) {
      promises.push( this.insertResporg( resporgsToInsert[i] ) );
    }

    /*
      Promises[0] - Wholesale Company Settings
      Promises[1 ... carrierDeletesLength] = Wholesale Company Carriers To Delete
      Promises[carrierDeletesLength + 1 ... carrierInsertsLength] = Wholesale Company Carriers To Insert
      Promises[carrierInsertsLength + 1 ... resporgsDeleteLength] = Wholesale Resporgs To Delete
      Promises[resporgsDeleteLength + 1 ... resporgsInsertLength] = Wholesale Resporgs To Insert
    */
    const all = () => Promise.all( promises ).then( ( results ) => {
      const args = {
        row: results[0].data[0],
      };

      this.getData();

      this.alert.SUCCESS( this.title, `Successfully updated ${this.title}.`, 2500 );

      this.setState( {
        changed: false
      } );

      if ( activeKey === this.startingKey ) {
        this.props.onSave( args );
      }

    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );

    all();
  }

  onValidateFields() {
    const row = this.state.row;
    const isNew = row.Company_ID === -1;

    if ( isNew === false ) {
      if ( parseInt( row.Play_Utility_DNIS, 10 ) !== 0 ) {
        if ( row.Utility_DNIS === '' || row.Utility_DNIS === null || row.Utility_DNIS === undefined ) {
          return 'You must enter a valid utility DNIS.';
        }
      }
    }

    return '';
  }

  onHandleClickSave( args ) {
    const row = { ...this.state.row };
    const activeKey = this.state.activeKey;

    if ( activeKey === 0 ) {
      const { bugsnag, dispatch } = this.props;
      const alert = new Alerts( bugsnag, dispatch );
      let message = this.onValidateFields();
      if ( message !== '' ) {
        alert.WARNING( this.title, message, 2500 );
        return;
      }

      const companyParams = {
        Company_ID: row.Company_ID,
        Company: row.Company,
        DEFDNIS: row.DEFDNIS,
        Address: row.Address,
        City: row.City,
        State: row.State,
        ZipCode: row.ZipCode,
        MDF_Owned: row.MDF_Owned,
        MDF_Controlled: row.MDF_Controlled,
        Active: row.Active,
        Inbound_SIP: row.Inbound_SIP,
        USE_DID_SHIELD: row.USE_DID_SHIELD,
        Route_Canada_To_Default: row.Route_Canada_To_Default,
        Play_Utility_DNIS: row.Play_Utility_DNIS,
        Utility_DNIS: row.Utility_DNIS,
        Utility_DNIS_RiskType_ID: row.Utility_DNIS_RiskType_ID
      };

      if ( row.Company_ID === -1 ) {
        this.onHandleInsertCompany( companyParams );
      } else {
        this.onHandleUpdateCompany( companyParams );
      }
    } else if ( activeKey === this.startingKey ) {
      /*
        Company, Contacts, SIP Info, and SIP Inbound passes this back to the
        parent which hands it back to ListContainer to rerender the update.
        This rerender only occurs if user is rendering sibling
        ListContainer/Dialog.

        Example:
        ListContainer = Contacts
        Dialog = Contacts
      */
      this.props.onSave( args );
    }
  }

  onHandleClickDelete( args ) {
    // Pass up to the parent to update ListContainer only if the dialog and ListContainer are linked
    if ( this.state.activeKey === this.startingKey ) {
      this.props.onDelete( args );
    }
  }

  /****************************************************************************
   * RENDERS
   ***************************************************************************/

  onRenderHeader( activeKey, row ) {
    let caption = this.title;

    if ( activeKey === 0 ) {
      if ( row.Company_ID === -1 ) {
        caption = 'Insert new Wholesale Company';
      } else {
        caption = `Edit ${this.title} - ${row['Company']}`;
      }
    } else if ( activeKey === 1 ) {
      caption = `Wholesale Contacts for ${row['Company']}`;
    } else if ( activeKey === 2 ) {
      caption = `Wholesale Numbers for ${row['Company']}`;
    } else if ( activeKey === 3 ) {
      caption = `SIP Info for ${row['Company']}`;
    } else if ( activeKey === 4 ) {
      caption = `SIP Inbound for ${row['Company']}`;
    } else if ( activeKey === 5 ) {
      caption = `TFN/DID Split for ${row['Company']}`;
    } else if ( activeKey === 6 ) {
      caption = `Wholesale Utility Numbers for ${row['Company']}`;
    } else if ( activeKey === 7 ) {
      caption = `Wholesale Resporgs for ${row['Company']}`;
    }

    return caption;
  }

  onRenderBody( activeKey, row ) {
    const isNew = row.Company_ID === -1 ? false : true;
    const showSIP = [undefined, false, null, 0].includes( this.state.startingSIP ) ? false : true;
    const showUtilityNumbers = parseInt( row.Play_Utility_DNIS, 10 ) === 0 ? false : true;
    return (
      <ProgramTabContainer onSelectTab={this.onHandleChangeTab} activekey={activeKey}>
        <ProgramTabPanel>
          <ProgramTabPanelItem caption="Settings" width="100px">
            <WholesaleSettings row={row} onChange={this.onHandleChange} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Contacts" width="100px" visible={isNew}>
            <WholesaleContacts row={row} onSave={this.onHandleClickSave} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Numbers" width="100px" visible={isNew}>
            <WholesaleNumbers row={row} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="SIP Info" width="100px" visible={showSIP}>
            <WholesaleSIPInfo row={row} onSave={this.onHandleClickSave} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="SIP Inbound" width="120px" visible={showSIP}>
            <WholesaleSIPInbound row={row} onSave={this.onHandleClickSave} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="TFN/DID Split" width="120px" visible={isNew}>
            <WholesaleTFNSplitEditDialog row={row} onClose={this.props.onClose} onSave={this.onHandleClickSave} onDelete={this.onHandleClickDelete} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Utility Numbers" width="200px" visible={showUtilityNumbers && isNew}>
            <WholesaleUtilityNumbers row={row} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Default Programs" width="200px" visible={isNew}>
            <WholesaleDefaultPrograms row={row} onSave={this.onHandleClickSave} onDelete={this.onHandleClickDelete} />
          </ProgramTabPanelItem>
          <ProgramTabPanelItem caption="Resp Org" width="120px" visible={isNew}>
            <WholesaleResporgs row={row} />
          </ProgramTabPanelItem>
        </ProgramTabPanel>
      </ProgramTabContainer>
    );
  }

  onRenderFooter( activeKey, row ) {
    let renderedFooter = [];

    if ( activeKey === 0 ) {

      renderedFooter.push(
        <button key="dialog-cancel-button" className="dialog-cancel-button" onClick={this.props.onClose}>
          Cancel
        </button>
      );

      renderedFooter.push(
        <button key="dialog-save-button" className="dialog-save-button" onClick={this.onHandleClickSave}>
          Save
        </button>
      );

    } else {
      renderedFooter.push(
        <button key="dialog-cancel-button" className="dialog-cancel-button" onClick={this.props.onClose}>
          Cancel
        </button>
      );
    }

    return renderedFooter;
  }

  render() {
    if ( this.props.show && this.state.row !== undefined ) {
      const row = this.state.row;
      const activeKey = parseInt( this.state.activeKey, 10 );
      const caption = this.onRenderHeader( activeKey, this.props.row );
      let width = 90;
      let height = 90;

      return (
        <div>
          <Overlay show={this.props.show} />
          <Dialog show={this.props.show} width={width} height={height}>
            <DialogHeader caption={caption} closeButton onClose={this.onHandleClose} />
            <DialogBody>
              {this.onRenderBody( activeKey, row )}
            </DialogBody>
            {
              activeKey !== 5
              &&
              <DialogFooter>
                {this.onRenderFooter( activeKey, row )}
              </DialogFooter>
            }
          </Dialog>
        </div>
      );
    }

    return null;
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( WholesaleCompanyDialog ) );


// WEBPACK FOOTER //
// ./src/content/wholesale/companies/components/WholesaleCompanyDialog.js